import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { localizationService } from '@shared-services/localization-service';
import { StyledButton } from 'client/widget-components/basicComponents/StyledButton';
import Text, {
    TextDomTag,
} from 'client/widget-components/basicComponents/Text';
import React from 'react';
import { useFilterSortContext } from '../utils/filterSortContext';

const { str } = localizationService;

interface ToggleFiltersButtonProps {
    isExpanded: boolean;
    count: number;
    onClick: () => void;
}

const getLabel = (isExpanded: boolean, count: number = 0) => {
    const key = isExpanded ? 'less-filters' : 'more-filters';
    return str(`ui.runtimessr.filtersort.${key}`, { count: count.toString() });
};

const ToggleFiltersButton = ({
    isExpanded,
    count,
    onClick,
}: ToggleFiltersButtonProps) => {
    const { styles } = useFilterSortContext();
    const { textStyle } = styles;

    return (
        <StyledButton
            data-auto=''
            styles={iconBtnDefaultStyles}
            onClick={onClick}
            aria-label='search'
            data-grab='collection-search-widget-icon-btn'
        >
            <Text
                styles={[labelDefaultStyles, textStyle?.title]}
                tag={TextDomTag.h4}
            >
                {getLabel(isExpanded, count)}
            </Text>
        </StyledButton>
    );
};

export default ToggleFiltersButton;

const iconBtnDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        width: 'fit-content',
    },
};

const labelDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        textDecoration: 'underline',
        textTransform: 'uppercase',
        margin: 0,
    },
};
